import { useMemo } from "react";
import PackAssignDropdown from "./PackAssignDropdown";
import { GroupementColorLabel } from "./GroupingsView";
import "./GroupingsView.css";

const GROUPEMENT_DROPDOWN_MAX_HEIGHT = 170;

export default function GroupementAssignDropdown({
  groupements = [],
  value = "",
  onChange = () => {},
  disabled = false,
  className = "",
  ariaLabel = "Choisir un groupement thématique",
  allowNone = true,
  excludeGroupementId = "",
}) {
  const options = useMemo(() => {
    const items = groupements
      .filter((grouping) => grouping.groupementId !== excludeGroupementId)
      .map((grouping) => ({
        value: grouping.groupementId,
        label: (
          <GroupementColorLabel color={grouping.color} title={grouping.title} />
        ),
      }));

    if (!allowNone) return items;

    return [
      {
        value: "",
        label: (
          <GroupementColorLabel
            empty
            title={
              groupements.length
                ? "Aucun groupement"
                : "Aucun groupement thématique"
            }
          />
        ),
      },
      ...items,
    ];
  }, [allowNone, excludeGroupementId, groupements]);

  return (
    <div className={`groupement-assign${className ? ` ${className}` : ""}`}>
      <PackAssignDropdown
        options={options}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        ariaLabel={ariaLabel}
        matchTriggerWidth
        openBelow
        menuMaxHeight={GROUPEMENT_DROPDOWN_MAX_HEIGHT}
        menuZIndex={2147483600}
        menuClassName="groupement-assign__menu"
        placeholder={
          allowNone ? null : <GroupementColorLabel empty title="Choisir…" />
        }
      />
    </div>
  );
}
